import {Box, HStack, Heading, Image, Text, VStack, getSize} from 'platform/foundation';
import styled from 'styled-components';

import i18n from '@dms/i18n';

import sphereImage from '../assets/sphere.png';

const CARD_HEIGHT = 31;
const IMAGE_SIZE = 42;

// this is custom banner, so custom styles are OK
// eslint-disable-next-line eag/no-css-property
const StyledWrapper = styled.div`
  background: radial-gradient(234.01% 141.42% at 0% 0%, #a9c9fe 0%, #dfd5ff 49.5%, #f4f3f9 100%);
  border-radius: ${({theme}) => theme.radii.medium};
  overflow: hidden;
  position: relative;
  width: 100%;
  height: ${getSize(CARD_HEIGHT)};
  padding-left: ${getSize(8)};
  padding-right: ${getSize(8)};
`;

export const AiLeadCard = () => (
  <StyledWrapper>
    <HStack spacing={8}>
      <Box>
        <Image
          src={sphereImage}
          alt="AI sphere"
          width={IMAGE_SIZE}
          height={IMAGE_SIZE}
          fit="cover"
        />
      </Box>

      <VStack spacing={2} height={CARD_HEIGHT} justify="center">
        <Heading size={4} color="primary">
          {i18n.t('page.settings.labels.aiLeadManagementTitle')}
        </Heading>
        <Text size="small" color="secondary">
          {i18n.t('page.settings.labels.aiLeadManagementDescription')}
        </Text>
      </VStack>
    </HStack>
  </StyledWrapper>
);
